type TagVariant = "success" | "info" | "warning" | "error" | "neutral";

/** A Recurly subscription state, as the Billing tab's Status tag and Next Billing Date read it. */
class Type {
	public static ACTIVE = new Type("active", "Active", "success", "date");
	public static IN_TRIAL = new Type("in_trial", "Trial", "info", "date");
	public static FUTURE = new Type("future", "Upcoming", "info", "date");
	public static CANCELED = new Type("canceled", "Canceled", "warning", "ends");
	public static EXPIRED = new Type("expired", "Expired", "neutral", "none");
	public static FAILED = new Type("failed", "Payment Failed", "error", "none");
	public static PAUSED = new Type("paused", "Paused", "neutral", "none");

	private constructor(
		public readonly value: string,
		public readonly label: string,
		public readonly tag: TagVariant,
		/** "date" bills on that date, "ends" is when a canceled subscription stops, "none" has neither. */
		public readonly nextBilling: "date" | "ends" | "none",
	) {}

	public static values(): Type[] {
		return [Type.ACTIVE, Type.IN_TRIAL, Type.FUTURE, Type.CANCELED, Type.EXPIRED, Type.FAILED, Type.PAUSED];
	}

	public static getByValue(value?: string) {
		return this.values().find((type) => type.value === value);
	}
}

export { Type as BillingSubscriptionStateType };
